"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveConstantValueBinding = void 0;
const resolveConstantValueBindingCallback_1 = require("../calculations/resolveConstantValueBindingCallback");
const resolveSingletonScopedBinding_1 = require("./resolveSingletonScopedBinding");
exports.resolveConstantValueBinding = (0, resolveSingletonScopedBinding_1.resolveSingletonScopedBinding)(resolveConstantValueBindingCallback_1.resolveConstantValueBindingCallback);
//# sourceMappingURL=resolveConstantValueBinding.js.map